<div class="dictation-control" [class.recording]="isRecording"
  [class.processing]="isProcessingTranscript"
  [class.auto-stopped]="autoStoppedByTimer && !isRecording"
  [class.disabled]="!canRecord || isConnecting">
  <button mat-icon-button type="button" class="dictation-toggle"
    [disabled]="!canRecord || isConnecting" (click)="toggleRecording()" [title]="getButtonTitle()"
    color="secondary" [class.recording]="isRecording">
    <mat-icon *ngIf="!isRecording" [class.rotating]="isConnecting">{{ isConnecting ? 'sync' : 'mic'
      }}</mat-icon>
    <mat-icon *ngIf="isRecording">stop</mat-icon>
  </button>

  <div class="dictation-meta" *ngIf="isRecording || isProcessingTranscript || autoStoppedByTimer">
    <div class="countdown" *ngIf="isRecording && countdownRemainingSeconds !== null">
      <mat-icon>timer</mat-icon>
      <span>{{ getCountdownDisplay() }}</span>
    </div>

    <div class="processing" *ngIf="isProcessingTranscript">
      <mat-icon>hourglass_empty</mat-icon>
      <span>Processing transcript...</span>
    </div>

    <div class="resume-hint" *ngIf="autoStoppedByTimer && !isRecording">
      <mat-icon>info</mat-icon>
      <span>Time limit reached. Tap mic to continue.</span>
    </div>
  </div>

  <div class="waveform" *ngIf="isRecording" aria-hidden="true">
    <span class="waveform-bar"
      *ngFor="let level of waveformLevels; let i = index; trackBy: trackByWaveformBar"
      [style.--wave-height.%]="level"></span>
  </div>
</div>